module.exports = __webpack_public_path__ + "img/gear-logo.3ce442a2.png";